/**
 * Monthly recurring-revenue contribution per plan, in INR.
 *
 * These are *placeholder* prices used to render the MRR KPI on the
 * overview screen until a real `billing` router lands. Once that
 * exists, replace this with a server-side aggregate.
 */
export const PLAN_MONTHLY_INR: Record<string, number> = {
  trial: 0,
  starter: 4_999,
  standard: 9_999,
  premium: 19_999,
  enterprise: 39_999,
};

/** Statuses that count toward MRR (active paying tenants). */
export const REVENUE_STATUSES = new Set(['active']);

export function monthlyRevenue(
  tenants: Array<{ plan: string; status: string }>,
): number {
  let total = 0;
  for (const t of tenants) {
    if (!REVENUE_STATUSES.has(t.status)) continue;
    total += PLAN_MONTHLY_INR[t.plan] ?? 0;
  }
  return total;
}

export function formatInr(n: number): string {
  if (n >= 10_00_000) {
    return `₹${(n / 1_00_000).toFixed(1)} L`;
  }
  if (n >= 1_000) {
    return `₹${(n / 1_000).toFixed(1)}k`;
  }
  return `₹${n.toLocaleString('en-IN')}`;
}
